export enum TeamMemberAuditEventActionsFilter {
  JoinedToTeam = 'JoinedToTeam',
  GuestPromoted = 'GuestPromoted',
  RoleChanged = 'RoleChanged',
  KickedOut = 'KickedOut',
  LeftTeam = 'LeftTeam',
  ContentsTransferred = 'ContentsTransferred',
}
